<div class="bg-theme-green rounded-xl w-full h-full">
  <div class="content absolute left-0 top-0 w-[100%] hidden p-5">
    <div class="absolute left-0 sm-home:left-72 top-0 w-38 2xs:w-64 md:left-90 lg:left-140 2xl:left-190
        h-29 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-green/home-why-pink-cloud-2.svg)] bg-right-top bg-contain bg-no-repeat">
    </div>
    <div class="absolute left-0 w-[600px] lg:w-[824px] top-70 sm-home:top-75 2xl:top-75
        h-30 2xl:h-35 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-green/home-why-blue-line.svg)] bg-right-bottom bg-contain bg-no-repeat">
    </div>
    <div class="absolute sm-home:ml-[24px] left-4 sm-home:left-92 md:left-107 lg:left-160 2xl:left-175
            top-78 sm-home:top-58 2xl:top-58
            w-48 sm-home:w-35 2xl:w-70
            h-32 sm-home:h-52 bg-top sm-home:bg-center 2xl:bg-top rounded-xl  bg-cover bg-no-repeat
            bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/subscription/event-02.webp)]">
    </div>
    <div class="absolute left-4 sm-home:left-10 top-7 2xs:top-12 w-55 xs-home:w-[330px] 2xs:w-96 lg:w-110 2xl:w-140 h-25">
      <h3 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold">Un tarif accessible, qui s’adapte à tes envies.</h3>
      <p class="font-theme-source text-sm xs-home:text-base lg:text-base text-theme-black mt-3 sm-home:mt-5 lg:mt-3 mr-7 xs:mr-2 2xs:mr-2 sm-home:mr-32 lg:mr-12">
        Pour donner à tout le monde, l’opportunité d’une belle rencontre, nos offres évoluent en fonction de tes possibilités.
        De l’access au premium, tu as la possibilité d’ajuster ta soirée au gré de tes ressentis.
      </p>
    </div>
  </div>
</div>

